export default "__VITE_ASSET__DjCff18l__"